allowAuthenticatedFreeTrialSkus